import useStyles from 'isomorphic-style-loader/useStyles';
import React, { Fragment, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchSkyfireMethods } from '../../utils';
import Template from '../../Contexts/Template';
import { getDescriptiveListingGridSizes, getDescriptiveListingGridSizesForLineup, } from '../../utils/gridHelpers';
import { useItemsInView } from '../../utils/useItemsInView';
import InfiniteGrid from './items/InfiniteGrid';
import HorizontalItem from './items/HorizontalItem';
import * as visualStyles from './VisualListing.scss';
import * as Styles from './DescriptiveListing.scss';
import { WINDOW_SIZE_ENUM } from '../../types/IWindowSize';
import { SET_STORAGE } from '../../actions/Storage';
import TabButton from './items/TabButton';
export default function DescriptiveListing(props) {
    useStyles(visualStyles);
    useStyles(Styles);
    const callbackRef = useItemsInView(props.onViewed);
    const { windowWidth } = useSelector((state) => state.BrowserState);
    const { addAllToPlaylistEnabled, addAllToPlaylistMaxTrackCount, actionButton, items, buttonsHeader, seeMoreItem, widgetType, } = props.data;
    const [activeIndex, setActiveIndex] = useState(0);
    const LINEUP = 'LINEUP';
    const dispatch = useDispatch();
    const template = useContext(Template);
    const updateButtonsHeader = (i) => {
        setActiveIndex(i);
    };
    // Collect up to MaxTrackCount tracks into SelectedItemsClientInterface to add to playlist
    // Done on front-end as ClientInterface cannot easily collect tracks across pagination
    // Upper case name to satisfy linter
    const OnButtonSelected = (methods) => {
        if (addAllToPlaylistEnabled) {
            items
                .slice(0, Math.min(addAllToPlaylistMaxTrackCount !== null && addAllToPlaylistMaxTrackCount !== void 0 ? addAllToPlaylistMaxTrackCount : 0, items.length))
                .forEach((item) => {
                var _a, _b, _c, _d;
                dispatch({
                    type: SET_STORAGE,
                    payload: {
                        group: 'MULTISELECT',
                        key: (_b = (_a = item.iconButton) === null || _a === void 0 ? void 0 : _a.observer) === null || _b === void 0 ? void 0 : _b.storageKey,
                        value: (_d = (_c = item.button) === null || _c === void 0 ? void 0 : _c.observer) === null || _d === void 0 ? void 0 : _d.storageKey,
                    },
                });
            });
        }
        dispatchSkyfireMethods(dispatch, template, methods);
    };
    const getGridSizes = () => {
        if (widgetType === LINEUP)
            return getDescriptiveListingGridSizesForLineup(windowWidth);
        return getDescriptiveListingGridSizes(windowWidth);
    };
    // Experimental 'Add All To Playlist' button only on homepage ShowCatalogTrack widgets
    // Add class for flexbox styling if we show button to render header and button inline
    // SeeMoreItem only when DescriptiveListing is used for Lineup Widget
    const getHeaderClassname = () => {
        if (seeMoreItem)
            return Styles.headerWithButtonClassname;
        return actionButton
            ? `${visualStyles.header} ${visualStyles.actionBtn}`
            : `${visualStyles.header}`;
    };
    return (React.createElement(Fragment, null,
        props.data.header && (React.createElement("div", { className: getHeaderClassname() },
            React.createElement("h1", { className: "music-headline-4" }, props.data.header),
            seeMoreItem && (React.createElement("music-button", { className: Styles.seeMoreItem, type: "button", variant: "glass", size: "medium", onClick: OnButtonSelected.bind(this, seeMoreItem.primaryLink.onItemSelected) }, seeMoreItem.text)),
            actionButton && (React.createElement("music-button", { type: "button", variant: "glass", size: "medium", data: actionButton, onClick: OnButtonSelected.bind(this, actionButton.onItemSelected), "icon-name": actionButton.icon, iconOnly: windowWidth <= WINDOW_SIZE_ENUM.MD }, actionButton.text)))),
        buttonsHeader && buttonsHeader.length > 1 && (React.createElement("div", { className: Styles.outerTabButtonContainer },
            React.createElement("div", { className: Styles.tabButtonContainer }, buttonsHeader.map((button, i) => (React.createElement(TabButton, { key: button.text, data: button, index: i, active: i === activeIndex, updateParentWithIndexProp: updateButtonsHeader })))))),
        React.createElement(InfiniteGrid, { data: props.data, handleSelected: props.handleSelected, componentType: HorizontalItem, gridSizes: getGridSizes(), isEnumerated: props.isEnumerated, itemsViewedRef: callbackRef, removeScrollTop: widgetType === LINEUP })));
}
